import { Tooltip } from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import AssignMemberToOrderStage from '@components/assign-team-member/AssignMemberToOrderStage';
import DateRangeComponent from '@components/DateRangeComponent';
import LoaderComponent from '@components/LoaderComponent';
import { toastSuccess } from '@components/Toast';

import useFetch from '@hooks/useFetch';

import ExFactorySupplierQuote from '@features/order-dashboard/component/ExFactorySupplierQuote';
import { canEditTaskDueDate } from '@features/order/utils/projectUtil';
import NewPostSection from '@features/task/components/OrderManageComponents/NewPostSection';

import tnaService from '@services/tna-service';

import { _getKey, capitalizeFirstLetter, getShortName, getUserInfo } from '@utils/Util';

// Handing over to the forwarder records the shipped quantity and ex-factory date, so completing it always goes
// through the shipment details modal, exactly as it does when the task is opened from the delivery column.
export const HANDOVER_TO_FORWARDER_STEP = 'Handover to forwarder';

const AllTask = ({ styleInfo, closeModal, callback, isSetProduct }) => {
	const [selectedStylePlanningDetail, setSelectedStylePlanningDetail] = useState([]);
	const { responseData: memberData } = useFetch('getProjectMembers', styleInfo?.orderId);
	const [, setDeliverableDetails] = useState(null);
	const [reviseInfo, setReviseInfo] = useState(null);
	const [taskId, setTaskId] = useState(null);
	const [handoverTaskId, setHandoverTaskId] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [activeSetMemberId, setActiveSetMemberId] = useState(null);
	const [isFinishTabVisible, setIsFinishTabVisible] = useState(false);
	const [productsOfSet, setProductsOfSet] = useState([]);

	const extractSetMembers = () => {
		const temp = [];
		const detailsOfSetMember = styleInfo?.tnaSetMemberResponseList;
		const detailsOfSetParent = styleInfo?.tnaResponse;
		detailsOfSetMember.forEach((style) => {
			style.forEach((item, i) => {
				if (i === 0) {
					temp.push({
						...item?.stepProduct
					});
				}
			});
		});
		detailsOfSetParent.forEach((item, i) => {
			if (i === 0) {
				temp.push({
					name: 'Finish',
					id: item?.stepProduct?.id
				});
			}
		});
		setActiveSetMemberId(temp[0]?.id);
		setProductsOfSet(temp);
	};

	useEffect(() => {
		if (isSetProduct) {
			extractSetMembers();
		}
	}, [isSetProduct]);

	const onChangeTabOfSetMember = (style, index) => {
		setActiveSetMemberId(style?.id);
		if (index === productsOfSet.length - 1) {
			setIsFinishTabVisible(true);
		} else {
			setIsFinishTabVisible(false);
		}
	};

	const renderTopHeader = () => (
		<div className="haeder-task-title d-flex align-items-center">
			<div className="header-photo mr-1">
				{isSetProduct && styleInfo.productFeatureImageUrlList ? (
					<div className="set-image-layout" style={{ width: '48px' }}>
						{styleInfo?.productFeatureImageUrlList.map((image, idx) => (
							<img
								key={`product_feature_image_${idx}`}
								src={image || `${process.env.PUBLIC_URL}/images/default_product.svg`}
								alt="product"
								style={{ width: '100%', height: '100%' }}
							/>
						))}
					</div>
				) : (
					<img
						src={
							styleInfo?.productFeatureImageUrl ||
							`${process.env.PUBLIC_URL}/images/default_product.svg`
						}
						alt="product"
					/>
				)}
			</div>
			<div className="header-info ml-2">
				<ul className="common-list-component">
					{styleInfo?.productReferenceNo && (
						<li>
							<span className="semibold-12">{styleInfo.productReferenceNo}</span>
						</li>
					)}
					{styleInfo?.productGroupName && <li>{styleInfo.productGroupName}</li>}
					{styleInfo?.category && <li>{styleInfo.category}</li>}
				</ul>
				<p className="regular-12 mt-1">{styleInfo?.poNumber}</p>
			</div>
		</div>
	);

	const getStyleDetails = async (rfqId, idOfSetMember = null) => {
		setIsLoading(true);
		const stylePlanningDetailResponse = await tnaService.getRunningTnaStyleDetails(
			styleInfo.orderId,
			rfqId,
			idOfSetMember
		);
		// let hiddenTaskList = stylePlanningDetailResponse.filter((item) =>
		// 	isExist(item.deliverableResponse.id)
		// );
		setSelectedStylePlanningDetail(stylePlanningDetailResponse);
		setIsLoading(false);
	};

	useEffect(() => {
		getStyleDetails(styleInfo.id, isSetProduct && activeSetMemberId);
	}, [isSetProduct, activeSetMemberId]);

	const onApproveTask = async (taskId) => {
		setIsLoading(true);
		const response = await tnaService.onApproveTask(taskId);
		if (response?.success) {
			callback();
			if (activeSetMemberId && !isFinishTabVisible) {
				await getStyleDetails(styleInfo.id, activeSetMemberId);
			} else {
				await getStyleDetails(styleInfo.id);
			}
		}
		setIsLoading(false);
	};

	const returnStatusIcon = (task) => {
		if (
			task?.formattedTaskStatus === 'EXPIRED' ||
			task?.formattedTaskStatus === 'PENDING' ||
			task?.formattedTaskStatus === 'RUNNING'
		)
			return (
				<>
					<img
						src={`${process.env.PUBLIC_URL}/icons/due-green.svg`}
						alt="due"
						className="state"
						onClick={() => {
							if (task?.stepName === HANDOVER_TO_FORWARDER_STEP) {
								setHandoverTaskId(task.id);
							} else onApproveTask(task.id);
						}}
					/>
					{task?.stepType === 'REVIEW' ? (
						<img
							className="state"
							src={`${process.env.PUBLIC_URL}/icons/Update-red.svg`}
							alt="update"
							onClick={() => {
								setReviseInfo({
									id: task.id,
									stepName: task.stepName
								});
								setTaskId(task.id);
							}}
						/>
					) : null}
				</>
			);
		else return <img src={`${process.env.PUBLIC_URL}/icons/Success.svg`} alt="" className="state" />;
	};

	const onChangeDateRange = async (value1, value2, id) => {
		const body = {
			// startDate: value1,
			endDate: value1
		};
		const endDateUpdateResponse = await tnaService.taskEndDateUpdate(body, id);
		if (endDateUpdateResponse?.success) {
			toastSuccess(endDateUpdateResponse?.message);
			if (activeSetMemberId && !isFinishTabVisible) {
				await getStyleDetails(styleInfo.id, activeSetMemberId);
			} else {
				await getStyleDetails(styleInfo.id);
			}
		}
	};

	const renderInputTargetItem = (task) => {
		if (task?.productionTarget) {
			return (
				<div className="production-details">
					<div className="production-details-btn">
						<span className="blue_dark_01">{task?.actualProductionQuantity || 0}</span>/
						{task?.productionTarget}
						<span className="percentage">
							(PO+{parseFloat(task.extraProductionTargetPercentage).toFixed(2)}%)
						</span>
						<span className="devider">|</span> Bal:
						<span className="gray_dark_01">
							{parseInt(task?.productionTarget) - parseInt(task?.actualProductionQuantity || 0)}
						</span>
					</div>
				</div>
			);
		}
	};

	const returnTaskRow = (task, deliverableId, stepLength) => {
		return (
			<div key={task?.id} className="single-task">
				<div className="d-flex justify-content-between align-items-center">
					<div className="w-100 d-flex align-items-center">
						{returnStatusIcon(task, deliverableId)}
						<div
							className="cursor-pointer regular-12 w-100"
							// onClick={() => onClickModalShow(deliverableId)}
						>
							<Tooltip
								title={stepLength > 1 ? task?.stepName : task?.stepDescription}
								placement={'top, left'}
								arrow
							>
								<span className="done regular-12 gray_dark_01">
									{getShortName(
										stepLength > 1 ? task?.stepName : task?.stepDescription,
										35
									)}
								</span>
							</Tooltip>

							{renderInputTargetItem(task)}
							{(task?.formattedTaskStatus === 'COMPLETED' ||
								task?.formattedTaskStatus === 'APPROVED' ||
								task?.formattedTaskStatus === 'LATE_APPROVED') && (
								<>
									<span className="green state ml-2 mr-1">
										<img
											src={`${process.env.PUBLIC_URL}/icons/tick-green.png`}
											className="mr-1"
										/>
										{task?.actualEndDate &&
											moment(task?.actualEndDate).format('D MMM, YY')}
									</span>
									{task?.dateOver > 0 && (
										<span className="red date-count state mr-1">+{task?.dateOver}</span>
									)}
								</>
							)}

							{task?.formattedTaskStatus === 'EXPIRED' && (
								<>
									<span className="status unsafe state ml-2 mr-1">
										<img
											src={`${process.env.PUBLIC_URL}/icons/alert-octagon-white.svg`}
											alt="update"
										/>{' '}
										+{task?.dateOver}
									</span>
								</>
							)}

							{task?.revisionCount && (
								<span className="status red-alert ml-1 mr-1">
									<img src={`${process.env.PUBLIC_URL}/icons/Update.svg`} alt="update" />
									{task?.revisionCount}
								</span>
							)}
						</div>
					</div>

					<AssignMemberToOrderStage
						memberList={memberData?.memberList}
						taskInfo={task}
						onAddOrDeleteSuccess={() => getStyleDetails(styleInfo.id)}
					/>
					<div className="date-details">
						{/* <span className="regular-12 mr-2">
							{task?.formattedTaskStatus === 'PENDING' && task?.isAffected && (
                                <img src={`${process.env.PUBLIC_URL}/icons/exclamation-circle.svg`} alt='circle-icon'/>
                            )}
                            {task?.previousEndDate && (
                                <span className="tag mr-2">
									{moment(task?.previousEndDate).format('D MMM, YY')}
								</span>
                            )}
						</span> */}
						<span>
							<DateRangeComponent
								item={{ value1: task?.startDate, value2: task?.endDate }}
								onChange={onChangeDateRange}
								itemId={task?.id}
								single
								disabled={!canEditTaskDueDate(task)}
							/>
						</span>
					</div>
				</div>
			</div>
		);
	};

	const onSetDeliverableDetails = (deliverable) => {
		callback();
		setDeliverableDetails(deliverable);
		setReviseInfo(null);
		setTaskId(null);
	};

	const resetRevisionInfo = () => {
		setReviseInfo(null);
	};

	const renderMaterialType = (material) => {
		let materialType = material?.stepMaterial?.materialType.replace('_', ' ');
		if (materialType === 'BRANDING') {
			return 'Accessories: ';
		} else {
			return `${capitalizeFirstLetter(materialType)}: `;
		}
	};

	const renderHeading = (style) => {
		return (
			style?.stepResponseList?.length > 1 && (
				<div key={style?.deliverableResponse.name} className="single-task ">
					<div className="d-flex justify-content-between align-items-center">
						<Tooltip title={style?.deliverableResponse.name} placement={'left'} arrow>
							<p className="done regular-14 gray_dark_01">
								{getShortName(style?.deliverableResponse.name, 60)}
							</p>
						</Tooltip>
					</div>
				</div>
			)
		);
	};

	const renderSetTabs = () => {
		return (
			<ul>
				{productsOfSet.map((member, index) => (
					<li
						key={member?.id}
						className={`${activeSetMemberId === member.id ? 'active' : ''}`}
						onClick={() => onChangeTabOfSetMember(member, index)}
					>
						{member.name !== 'Finish' && 'TNA for'} {member?.name}
					</li>
				))}
			</ul>
		);
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div role="document">
				<div>
					<div className="modal-header">
						{renderTopHeader()}
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={closeModal}
						>
							<span aria-hidden="true">
								<svg
									width={14}
									height={14}
									viewBox="0 0 14 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
										fill="#222222"
										fillOpacity="0.87"
									/>
								</svg>
							</span>
						</button>
					</div>
					<div className="modal-body custom-scrollbar">
						<div className="tna-accordion-container">
							<div className="inner-tabs pb-12 pl-12 pt-12 mb-2 mt-2">
								{isSetProduct && activeSetMemberId && renderSetTabs()}
							</div>
							<div className="accordion" id="accordionTna">
								{selectedStylePlanningDetail?.map((style) => {
									return (
										<div key={style?.deliverableResponse.id} className="card">
											<div className="card-body">
												<div className="all-tna-tasks">
													{style?.stepResponseList && (
														<div className="materials-task-group">
															{renderHeading(style)}
															{style?.stepResponseList &&
																style?.stepResponseList.map((task) =>
																	returnTaskRow(
																		task,
																		style?.deliverableResponse?.id,
																		style?.stepResponseList?.length
																	)
																)}
														</div>
													)}
													{style?.materialWiseStepInfoList &&
														style?.materialWiseStepInfoList.map((material) => {
															return (
																<div
																	className="materials-task-group"
																	key={`task_${_getKey()}`}
																>
																	<div
																		key={
																			material?.stepMaterial
																				.materialName
																		}
																		className="single-task "
																	>
																		<div className="d-flex justify-content-between align-items-center">
																			<Tooltip
																				title={
																					material?.stepMaterial
																						.materialName
																				}
																				placement={'left'}
																				arrow
																			>
																				<p className="done regular-14 gray_dark_01">
																					{renderMaterialType(
																						material
																					)}{' '}
																					{getShortName(
																						material?.stepMaterial
																							.materialName,
																						60
																					)}
																				</p>
																			</Tooltip>
																		</div>
																	</div>
																	{material?.stepResponseList.map(
																		(task) => {
																			return returnTaskRow(
																				task,
																				style?.deliverableResponse?.id
																			);
																		}
																	)}
																</div>
															);
														})}
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
					{handoverTaskId !== null && (
						<ExFactorySupplierQuote
							rfqId={styleInfo?.id}
							onCloseModal={() => setHandoverTaskId(null)}
							onSuccess={() => {
								onApproveTask(handoverTaskId);
								setHandoverTaskId(null);
							}}
							supplierDetails={{
								supplierName: styleInfo?.factoryName,
								supplierId: styleInfo?.factoryId
							}}
						/>
					)}
					{taskId !== null && reviseInfo !== null && (
						<NewPostSection
							onSetDeliverableDetails={onSetDeliverableDetails}
							onAddNewPost={() => false}
							orderMemberList={memberData?.memberList}
							userInfo={getUserInfo()}
							onGetCommentsData={() => false}
							deliverableId={taskId}
							orderId={styleInfo?.orderId}
							reviseInfo={reviseInfo}
							brandName={styleInfo?.brandName}
							onResetRevise={() => setReviseInfo(null)}
							resetRevisionInfo={resetRevisionInfo}
						/>
					)}
				</div>
			</div>
		</LoaderComponent>
	);
};

export default AllTask;
